import React from 'react';
import './style.scss';
import cn from 'classnames';

export const StatusLabel = ({ children, type, className }) => {
  return <span className={cn('status-label', `status-label_${type}`, className)}>{children}</span>;
};
